/* Stickiply Learn: the "Browse ▾" disclosure (snippets/learn-browse, on every
 * Learn page: hub masthead, blog lists, Watch heading row, article masthead)
 * (click / ArrowDown / Enter / Space open; arrows + Home/End move; Esc, Tab
 * and outside click/focus close). Works for any number of [data-lh-menu]
 * instances; re-scans on shopify:section:load (theme editor). The old sticky
 * category bar and its fixed/spacer logic were removed on 21 Aug (Thomas: no
 * bar anywhere). No framework, no dependencies. Loaded by the snippet. */
(function () {
  "use strict";
  if (window.__learnHubInit) return;
  window.__learnHubInit = true;
  function ready(fn) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn(); }
  function init(root) {
    var menus = (root || document).querySelectorAll("[data-lh-menu]");
    Array.prototype.forEach.call(menus, function (menu) {
      if (menu.__lhMenu) return;
      menu.__lhMenu = true;
      var btn = menu.querySelector("[data-lh-menu-btn]");
      var panel = menu.querySelector("[data-lh-menu-panel]");
      if (!btn || !panel) return;
      function items() { return Array.prototype.slice.call(panel.querySelectorAll("a,button")); }
      function open() { panel.hidden = false; btn.setAttribute("aria-expanded", "true"); }
      function close(focusBtn) { panel.hidden = true; btn.setAttribute("aria-expanded", "false"); if (focusBtn) btn.focus(); }
      function isOpen() { return !panel.hidden; }
      btn.addEventListener("click", function () { isOpen() ? close(false) : open(); });
      btn.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || (e.key === "Enter" && !isOpen()) || e.key === " ") {
          e.preventDefault(); open(); var it = items(); if (it[0]) it[0].focus();
        } else if (e.key === "Escape") { close(true); }
      });
      panel.addEventListener("keydown", function (e) {
        var it = items(); var i = it.indexOf(document.activeElement);
        if (e.key === "Escape") { e.preventDefault(); close(true); }
        else if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); (it[i + 1] || it[0]).focus(); }
        else if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); (it[i - 1] || it[it.length - 1]).focus(); }
        else if (e.key === "Home") { e.preventDefault(); it[0] && it[0].focus(); }
        else if (e.key === "End") { e.preventDefault(); it[it.length - 1] && it[it.length - 1].focus(); }
        else if (e.key === "Tab") { close(false); }
      });
      document.addEventListener("click", function (e) { if (isOpen() && !menu.contains(e.target)) close(false); });
      document.addEventListener("focusin", function (e) { if (isOpen() && !menu.contains(e.target)) close(false); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && isOpen()) close(true); });
    });
  }
  ready(function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) { init(e.target || document); });
})();
